import React from 'react';
import AccountMobileNavigation from './AccountMobileNavigation/AccountMobileNavigation';
import AccountDesktopNavigation from './AccountDesktopNavigation/AccountDesktopNavigation';

/**
 * Renders the Account navigation
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AccountNavigation = (props) => (
  <div className="c-account-navigation">
    <AccountDesktopNavigation {...props} />
    <AccountMobileNavigation {...props} />
  </div>
);

export default AccountNavigation;
